export default __webpack_public_path__ + "static/media/DNo.9-2.8d4b9826.jpg";